import qs from 'qs';

export default function syncPushState(paramId, selected) {
  const params = qs.parse(window.location.search.slice(1));
  const newTypes = selected;
  const oldTypes = params[paramId] || newTypes;
  const removedType = Array.isArray(newTypes) ? newTypes.reduce((ok, v) => ok && oldTypes.indexOf(v) !== -1, true) : oldTypes;

  params[paramId] = newTypes;

  if (params[paramId] == null || (Array.isArray(params[paramId]) && params[paramId].length === 0)) {
    delete params[paramId];
  }

  if (paramId !== 'page') {
    delete params.page;
  }

  router.push({
    pathname: window.location.pathname,
    search: qs.stringify(params, { arrayFormat: 'brackets' }),
    state: { revisitWithSearch: true, removedType },
  });
}
